import React, { useState } from 'react';
import { fetchReset, fetchSinToken } from 'helpers/fetch';
import { Link } from 'react-router-dom';
import SLUGS from 'resources/slugs';
import fondo from 'images/login/recuperacion_contrasena/fondo.png';
import videomz from 'images/login/microzync.m4v'
import logo from 'images/login/logo.png';
import amazon from 'images/login/recuperacion_contrasena/amazon2.png'
import shopify from 'images/login/recuperacion_contrasena/shopify2.png'
import mercado_libre from 'images/login/recuperacion_contrasena/mercado_libre2.png'
import woocomerce from 'images/login/recuperacion_contrasena/woocomerce2.png'
import Swal from 'sweetalert2';

const Activation = ({ history, match }) => {

    const [loading, setLoading] = useState(false);
    const { token } = match.params;
    const isMobile = window.innerWidth <= 767;
    let [error, setError] = useState(['']);
    let [errores, setErrores] = useState({});
    let [success, setSuccess] = useState(['']);
    let [correo, setCorreo] = useState(false);
    let [email, setEmail] = useState('');
    const handleInputChange = ({ target }) => {
        setEmail(target.value)
    }

    const handleReenviar = () => {
        fetchSinToken('Usuarios/ReenviarLink?correo=' + email, null, 'GET')
            .then((response) => {
                setLoading(false);

                if (response.hasOwnProperty('status')) {
                    Object.entries(response.errors).forEach(([, value]) => {
                        Swal.fire('Error', value[0], 'error')
                        setLoading(false);
                    });
                    return false;
                } else if (response.hasOwnProperty('codigo') && response.codigo !== 200) {
                    Swal.fire('Error', response.mensajes[0], 'error')
                    setLoading(false);
                    return false;
                }
                Swal.fire('Exito', 'Se ha enviado el enlace de activación a su correo', 'success')
                history.push(SLUGS.login);
            })
            .catch((_) => setLoading(false));
    }

    const handleLogin = () => {
        setLoading(true);
        setErrores('');
        setError('');
        setSuccess('');
        fetchReset("Usuarios/ActivaUsuario", null, "POST", token).then(response => {
            setLoading(false);
            if (response.hasOwnProperty('status') && response.status === 400) {
                Object.entries(response.errors).map(([_, value]) => Swal.fire("Error", value[0], 'error'));
                return false;
            } else if (response.hasOwnProperty('codigo') && response.codigo !== 200) {
                Swal.fire("Error", response.mensajes[0], 'error');
                if (response.mensajes[0] === "Enlace vencido") setCorreo(true);

                return false;
            }
            setLoading(false);
            Swal.fire("Exitoso", 'Se activo la cuenta', 'success');
        }).catch(error => {
            setLoading(false);
            if (error.response.status === 401) Swal.fire("Error", error.response.data.message, 'error');
            else Swal.fire("Error", 'Error al recuperar su cuenta.', 'error');
        });
    }

    return (<>
        <div className={isMobile ? 'col-md-12' : 'col-md-12 row'} >
            <div
                className='col-12 col-sm-12 col-md-12 row login'
                style={{ minHeight: '100vh', marginLeft: '0', textAlign: 'center' }}
            >
                <div className='col-12 col-md-7'
                    style={{

                        backgroundRepeat: 'no-repeat',
                        display: window.innerWidth < 768 ? 'none' : 'block',
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                        position: 'relative',
                        backgroundColor: '#FAFAFA'
                    }}
                >
                    <video src={videomz} loop muted width="100%" id="background-video" height="380" type="video/mp4" autoplay="true" />
                    <div className='text-center' style={{
                        position: 'absolute',
                        top: '75%',
                        left: '50%',
                        height: '30%',
                        width: '80%',
                        margin: '-15% 0 0 -40%'
                    }}
                    >
                        <h2 style={{ color: "#0F5EF6" }}><b>¡Conectamos sistemas!</b></h2>
                        <br></br>
                        <p style={{ color: "#01295F" }}>Administra tu negocio desde una sola plataforma, sincroniza stock, precios, ventas y mucho mas!.</p>
                        <p style={{ color: "#01295F" }}>Descarga ventas, guias de envío, clientes.</p>
                        <p style={{ color: "#01295F" }}>Crea nuevos artículos y duplícalos.</p>
                        <div className='col-md-12 row' style={{ paddingTop: "5%" }}>
                            <div className='col-3 col-sm-3 col-md-3'>
                                <img src={woocomerce} alt='' />
                            </div>
                            <div className='col-3 col-sm-3 col-md-3'>
                                <img src={amazon} alt='' />
                            </div>
                            <div className='col-3 col-sm-3 col-md-3'>
                                <img src={mercado_libre} alt='' />
                            </div>
                            <div className='col-3 col-sm-3 col-md-3'>
                                <img src={shopify} alt='' />
                            </div>
                        </div>
                        <div style={{ background: 'rgba(245, 245, 245, 1)' }}>
                            <div className=' col-12 col-sm-12 col-md-12 row text-center' >
                                <div className='col-4 col-sm-4 col-md-4'>
                                    <a href="https://atti.com.mx" target="_blank" rel="noopener noreferrer">AttiSolutions</a>
                                </div>
                                <div className='col-4 col-sm-4 col-md-4'>
                                    <a href={SLUGS.terminoscondiciones} target="_blank" rel="noopener noreferrer">Términos y condiciones</a>
                                </div>
                                <div className='col-4 col-sm-4 col-md-4'>
                                    <a href={SLUGS.avisoprivacidad} target="_blank" rel="noopener noreferrer">Aviso de privacidad</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='col-md-5' style={{ marginTop: "5%" }} >
                    <div
                        className='col-12'
                        style={{
                            backgroundRepeat: 'no-repeat',
                            backgroundPosition: 'center',
                            backgroundAttachment: 'fixed',
                            backgroundImage: window.innerWidth < 768 ? `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)),url(${fondo})` : 'none',
                            backgroundSize: 'cover',

                        }}
                    >
                        <form>
                            <div className='card' style={{
                                boxShadow: 'rgb(30 56 136 / 20%) 8px 8px 48px',
                                borderRadius: '8px'
                            }}>
                                <div>
                                    <div className='col-md-12 text-center'>
                                        <Link to={SLUGS.home}>
                                            <img src={window.innerWidth < 768 ? logo : logo} className="img-fyt" alt='' />
                                        </Link>
                                        <h2 style={{ color: '#01295F' }}>
                                            <b>Activación de cuenta!</b>
                                        </h2>
                                        <br></br>
                                    </div>
                                    <div className='col-md-11 container text-center' style={{ paddingBottom: '15px' }}>
                                        {error && (
                                            <>
                                                <small style={{ color: 'red' }}>{error}</small>
                                                <br />
                                            </>
                                        )}
                                        <div className='card-body text-start'>
                                            <div className='col-md-12 text-center'>
                                                <p style={{ color: 'red' }}>{error}</p>
                                                <p style={{ color: 'blue' }}>{success}</p>
                                                {Object.entries(errores).map(([key, value]) => { return (<><p style={{ color: 'red' }}>{value}</p></>); })}
                                            </div>
                                            <input style={{ color: "white", borderRadius: "15px", background: "#189ad6", width: "100%" }} type="button" className="btn btn-info col-md-8" value={loading ? 'Cargando...' : 'Activa tu cuenta'} onClick={handleLogin} disabled={loading} /><br />
                                            {correo ? <div className='col-md-12 text-center'>
                                                <label
                                                    style={{
                                                        color: '#01295F'
                                                    }}
                                                >
                                                    <b>Escribe tu correo y se te reenviara un link de activación</b>
                                                </label>
                                                <input
                                                    type='email'
                                                    value={email}
                                                    name='email'
                                                    className='form-control'
                                                    placeholder='correo'
                                                    onChange={handleInputChange}
                                                />
                                                <br></br>
                                                <input
                                                    type='button'
                                                    className='btn btn-info button-login'
                                                    value={loading ? 'Cargando...' : 'Enviar'}
                                                    onClick={handleReenviar}
                                                    disabled={loading}
                                                    style={{ width: "100%" }}
                                                />
                                            </div> : ''}
                                            <div className='col-md-12 text-center'>
                                                <br></br>
                                                <b><Link to={SLUGS.login} style={{ color: window.innerWidth < 768 ? "##0F5EF6" : "##0F5EF6" }}>Volver a inicio de sesión</Link></b>
                                                <br></br>
                                                <br></br>
                                                <p >¿Aún no tienes una cuenta?<Link to={SLUGS.register}>Registrate aquí</Link></p>
                                            </div>
                                            <br></br>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            {isMobile ? <div className='col-md-12' >
                <div className='' style={{ padding: "15px 15% 20px 15%" }}>
                    <div className='text-center'>
                        <h2 style={{ color: "#0F5EF6" }}><b>¡Conectamos sistemas!</b></h2>
                    </div>
                    <br></br>
                    <p style={{ color: "#01295F" }}>Administra tu negocio desde una sola plataforma, sincroniza stock, precios, ventas y mucho mas!.</p>
                    <p style={{ color: "#01295F" }}>Descarga ventas, guias de envío, clientes.</p>
                    <p style={{ color: "#01295F" }}>Crea nuevos artículos y duplícalos.</p>
                    <div className='col-md-12 row' style={{ paddingTop: "5%" }}>
                        <div className='col-3 col-sm-3 col-md-3'>
                            <img src={woocomerce} alt='' />
                        </div>
                        <div className='col-3 col-sm-3 col-md-3'>
                            <img src={amazon} alt='' />
                        </div>
                        <div className='col-3 col-sm-3 col-md-3'>
                            <img src={mercado_libre} alt='' />
                        </div>
                        <div className='col-3 col-sm-3 col-md-3'>
                            <img src={shopify} alt='' />
                        </div>
                    </div>
                    <br></br>
                </div>
                <div style={{ background: 'rgba(245, 245, 245, 1)' }}>
                    <div className=' col-12 col-sm-12 col-md-12 row text-center' >
                        <div className='col-4 col-sm-4 col-md-4'>
                            <a href="https://atti.com.mx" target="_blank" rel="noopener noreferrer">AttiSolutions</a>
                        </div>
                        <div className='col-4 col-sm-4 col-md-4'>
                            <a href={SLUGS.terminoscondiciones} target="_blank" rel="noopener noreferrer">Términos y condiciones</a>
                        </div>
                        <div className='col-4 col-sm-4 col-md-4'>
                            <a href={SLUGS.avisoprivacidad} target="_blank" rel="noopener noreferrer">Aviso de privacidad</a>
                        </div>
                    </div>
                </div>
            </div> : ''}
        </div>
    </>);
}

export { Activation };